"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Button = _interopRequireDefault(require("../Button/Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var stepsShape = _propTypes.default.shape({
  label: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.element]).isRequired
});

/**
 * The StepBar component helps the user visualize his progress in a series of steps.
 * Unless the ProgressBar component, each step already completed can be clickable and bring the user back to that step.
 */
var StepBar = function StepBar(_ref) {
  var controlledSteps = _ref.steps,
    controlledCurrentStep = _ref.currentStep,
    enableForwardSteps = _ref.enableForwardSteps,
    className = _ref.className,
    handleClick = _ref.handleClick,
    onClick = _ref.onClick;
  var _React$useState = _react.default.useState(0),
    currentStep = _React$useState[0],
    setCurrentStep = _React$useState[1];
  var _React$useState2 = _react.default.useState([]),
    stepList = _React$useState2[0],
    setStepList = _React$useState2[1];
  _react.default.useEffect(function () {
    setCurrentStep(controlledCurrentStep || 0);
  }, [controlledCurrentStep]);
  _react.default.useEffect(function () {
    setStepList(controlledSteps || []);
  }, [controlledSteps]);
  var handleStepClick = function handleStepClick(stepIndex) {
    setCurrentStep(stepIndex);
    if (typeof onClick === 'function') {
      onClick(stepIndex);
    }
    // Legacy: will be deprecated in v.1.0.0
    if (typeof handleClick === 'function') {
      handleClick(stepIndex);
    }
  };
  var getSteps = stepList.map(function (step, i) {
    var stepClass = '';
    var clampedStep = Math.min(Math.max(currentStep, 0), controlledSteps.length - 1);
    if (clampedStep === i) {
      stepClass = 'step--current';
    } else if (clampedStep > i) {
      stepClass = 'step--completed';
    }
    if (step.disabled) {
      stepClass = '';
    }
    var label = /*#__PURE__*/_react.default.isValidElement(step.label) ? step.label : /*#__PURE__*/_react.default.createElement('span', {
      tabIndex: 0
    }, step.label);
    console.log(clampedStep);
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      key: "step-" + i,
      className: (0, _clsx.default)('uk-step', stepClass),
      onClick: function onClick() {
        return handleStepClick(i);
      },
      disabled: !enableForwardSteps && (clampedStep < i || step.disabled),
      "aria-current": clampedStep === i ? true : null
    }, clampedStep > i && /*#__PURE__*/_react.default.createElement("span", {
      className: "show-for-sr"
    }, "Step " + (i + 1) + " of " + controlledSteps.length + ": " + step.label + " is completed"), label);
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('uk-stepbar', className),
    "aria-label": "progress",
    role: "group"
  }, getSteps);
};
StepBar.propTypes = {
  /**
   * Array of steps
   */
  steps: _propTypes.default.arrayOf(stepsShape),
  /**
   * Index of the current step (0-based index)
   */
  currentStep: _propTypes.default.number,
  /**
   * Activate click on forward steps
   */
  enableForwardSteps: _propTypes.default.bool,
  /**
   * Callback function onClick
   */
  onClick: _propTypes.default.func,
  /**
   * Legacy: will be deprecated in v.1.0.0
   */
  handleClick: _propTypes.default.func
};
StepBar.defaultProps = {
  currentStep: 0,
  enableForwardSteps: false
};
var _default = exports.default = StepBar;